var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"menu-bar",attrs:{"default-active":_vm.$router.path,"collapse":_vm.isCollapse,"unique-opened":""}},[_c('menu-item',{attrs:{"menuList":_vm.menuList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }